import { createContext } from "react";

const SubCategoriasContext = createContext();

export default SubCategoriasContext;
